<template>
    <div class="con-btn">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>清除资产单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>清除信息</span>
        </div>
        <el-form :model="clearVoucher" :rules="voucherInfo" ref="ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">清除机构</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="bizUnitId" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="clearVoucher.bizUnitName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectBizUnitName" v-if="!srcCheck"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">清除日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="theDate">
                            <el-date-picker v-model="clearVoucher.theDate" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>审核单号</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="auditPoofNo">
                            <el-input type="text" v-model="clearVoucher.auditPoofNo" placeholder="请输入单号" :disabled="srcCheck"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="showBizUnitWarehouse && !srcCheck">
                    <div class="form-label">
                        <label class="required">仓库名称</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="warehouseId">
                            <el-select v-model="clearVoucher.warehouseId" placeholder="请选择" @change="compareIn" style="width: 150px">
                                <el-option v-for="item in wareHouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>资产信息</span>
            <div class="input-tip error fr font12">提示:一次清除数据最多500条</div>
        </div>
        <div class="simple-row" v-if="!srcCheck">
            <div class="left">
                <el-button type="primary" @click="showDeviceListDlg()">
                    <span>通用选择</span>
                </el-button>
            </div>
        </div>
        <div class="simple-row">
            <div class="left">
                <div class="input-tip error">提示:资产如果在套装中,将解除关联套装,如果资产是套装主资产则套装将解散。</div>
            </div>
            <div class="right">
                <span v-if="clearVoucher.deviceItemList != null">已选择({{clearVoucher.deviceItemList.length}})</span>
                <a v-if="clearVoucher.deviceItemList != null && clearVoucher.deviceItemList.length>0" class="swb-btn swb-btn-small swb-btn-primary" @click="setStaff">设置人员</a>
                <a v-if="clearVoucher.deviceItemList != null && clearVoucher.deviceItemList.length>0 && !srcCheck" class="swb-btn swb-btn-small swb-btn-primary" @click="selectDeviceClearDeasc()">清除原因</a>
            </div>
        </div>
        <div class="table-layout" style="width: 100%;overflow-x: auto">
            <el-form :model="clearVoucher" ref="deviceInfo">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th width="180" style="text-align: left;">资产描述全称</th>
                        <th width="180" style="text-align: left;">名称</th>
                        <th width="150" style="text-align: left;">型号</th>
                        <th width="150" style="text-align: left;">规格</th>
                        <th width="250">系统编号</th>
                        <th width="150">外部系统编号</th>
                        <th width="250">商品标识码</th>
                        <th width="100" style="text-align: left;">分类</th>
                        <th width="100" style="text-align: left;">分类分组</th>
                        <th width="120" style="text-align: left;">品牌</th>
                        <th width="90" style="text-align: center;">财务类别</th>
                        <th width="90" style="text-align: center;">入账方式</th>
                        <th width="130">清除部门</th>
                        <th width="100">清除人</th>
                        <th width="160" style="text-align: left;">批次号</th>
                        <th width="250">资产编号</th>
                        <th width="80">在库数量</th>
                        <th width="80">财务在账数量</th>
                        <th width="80">可清除数量</th>
                        <th width="80">清除数量</th>
                        <th width="80">单位</th>
                        <th width="100">清理费用</th>
                        <th width="100">清理收入</th>
                        <th width="120">清除原因</th>
                        <th width="120" style="text-align: left;">备注</th>
                        <th width="120" style="text-align: left;">管理方式</th>
                        <th width="120">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr class="row" v-for="(deviceItem, index) in clearVoucher.deviceItemList">
                        <td style="text-align: left;">{{deviceItem.title}}</td>
                        <td style="text-align: left;">{{deviceItem.name}}</td>
                        <td style="text-align: left;">{{deviceItem.model}}</td>
                        <td style="text-align: left;">{{deviceItem.fixedSpec}}</td>
                        <td>{{deviceItem.tmpNo}}</td>
                        <td>{{deviceItem.innerNo}}</td>
                        <td>{{deviceItem.vendorUkno}}</td>
                        <td style="text-align: left;">{{deviceItem.catName}}</td>
                        <td style="text-align: left;">{{deviceItem.devcGroupFullName}}</td>
                        <td style="text-align: left;">{{deviceItem.brandName}}</td>
                        <td style="text-align: left;">{{deviceItem.assetKindName}}</td>
                        <td style="text-align: center;">{{acctEnterWayMap[deviceItem.acctEnterWay]}}</td>
                        <td>{{deviceItem.departName}}</td>
                        <td>{{deviceItem.staffName}}</td>
                        <td style="text-align: left;">{{deviceItem.batchNo}}</td>
                        <td style="text-align: left;">{{deviceItem.innerCode}}</td>
                        <td style="text-align: left;">{{deviceItem.inStkQuantity}}</td>
                        <td style="text-align: left;">{{deviceItem.fiscalQuantity}}</td>
                        <td style="text-align: left;">
                            <span>{{deviceItem.fiscalAcctFlag == 0 ? deviceItem.inStkQuantity : (deviceItem.inStkQuantity < (deviceItem.fiscalOutQuantity - deviceItem.clearedQuantity) ? deviceItem.inStkQuantity : (deviceItem.fiscalOutQuantity - deviceItem.clearedQuantity))}}</span>
                        </td>
                        <td style="text-align: left;">
                            <!-- 清除可用数量 -->
                            <template v-if="deviceItem.assetType == 0">1</template>
                            <template v-else>
                                <el-form-item :prop="'deviceItemList.' + index + '.clearAvQuantity'" :rules="{validator: inputClearQuantity, trigger: 'blur'}">
                                    <el-input type="number" min="0" class="input-content-right" @change="quantityChange(deviceItem);" v-model.number="deviceItem.clearAvQuantity" :disabled="srcCheck"></el-input>
                                </el-form-item>
                            </template>
                        </td>
                        <td>{{deviceItem.theUnit}}</td>
                        <td style="text-align: left;">
                            <el-form-item :prop="'deviceItemList.' + index + '.theFee'" :rules="{validator: inputTheFee, trigger: 'blur'}">
                                <el-input class="input-content-left" type="text" v-model="deviceItem.theFee"></el-input>
                            </el-form-item>
                        </td>
                        <td style="text-align: left;">
                            <el-form-item :prop="'deviceItemList.' + index + '.theInc'" :rules="{validator: inputTheInc, trigger: 'blur'}">
                                <el-input class="input-content-left" type="text" v-model="deviceItem.theInc"></el-input>
                            </el-form-item>
                        </td>
                        <td style="text-align: left;">
                            <el-select v-if="deviceItem.checked == true" v-model="deviceItem.clearCause" placeholder="请选择" :disabled="srcCheck">
                                <el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </td>
                        <td style="text-align: left;">
                            <el-input class="textarea-value" type="textarea" v-model="deviceItem.memo"></el-input>
                        </td>
                        <td>{{deviceItem.assetType == 0 ? '单品式管理' : '批量式管理'}}</td>
                        <td style="text-align: left;">
                            <a class="swb-btn-link" @click="removeDeviceItem(index)" v-if="!srcCheck">移除</a>
                            <a class="swb-btn-link" @click="setStaffInfo(index)">设置人员</a>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot" v-if="clearVoucher.deviceItemList == null || clearVoucher.deviceItemList.length == 0">
                    <tr class="row">
                        <td colspan="18">
                            <span class="block font-gray3">请选择资产</span>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </div>
        <div class="content-caption dashed">
            <span>附加信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input type="textarea" v-model="clearVoucher.memo"></el-input>
                </div>
            </div>
        </div>
        <div class="form-toolbar">
            <a class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</a>
            <a class="swb-btn swb-btn-small" @click="saveDeviceIoVoucher">保存</a>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { MsgBox, Vue } from '../../app.vues'
    import { openBizUnitOrgTreeDlg, openComStaffMainForSelectDlg } from '../orgStruct/selectDlg'
    import { getDevcGroupNameByCatId, isSysRescFrozenIsAllowed, syncSetBreadcrumb } from '../index'
    import { getMerchantBizParam } from '../asset/assetMain'
    import { showDevcSelectDlg } from '../devc/selectDlg'
    import shopStockApi from '../../api/shopStock'
    import assetVchrApi from '../../api/assetVchr'

    import SwbShopDeviceClearVoucherApplyList from './ShopDeviceClearVoucherApplyList.vue'

    Vue.regist(SwbShopDeviceClearVoucherApplyList);

    export default {
        name: 'swb-save-device-clear-voucher',
        path: '/save/device/clear/voucher',
        avlActions: '',
        avlScopes: 'vendor',
        notAsResc: true,
        authen: false,
        customBreadcrumb: true,
        desc: '清除单 - 制作',
        data: function () {
            let validateWarehouseId = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择仓库'));
                } else {
                    callback();
                }
            };
            let validateTheDate = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择日期'));
                } else {
                    callback();
                }
            };
            return {
                clearVoucher: {
                    theDate: new Date(),
                    warehouseId: null,
                    auditPoofNo: null,
                    deviceItemList: [],
                    bizUnitId: null,
                    bizUnitName: null
                },
                // 高级选择条件
                selectSingleIds: [],
                voucherId: null,
                //
                autoApplyAndAudit: false,
                autoApplyState: false,
                autoAuditPass: false,
                //
                wareHouseList: [],
                devcClearCauseList: getEnumList("devcClearCause"),
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                voucherInfo: {
                    warehouseId: [{validator: validateWarehouseId, trigger: 'blur'}],
                    theDate: [{validator: validateTheDate, trigger: 'blur'}]
                },
                parentPath: null,
                showBizUnitWarehouse: false,
                srcCheck: false
            }
        },
        created: function () {
            let self = this;
            this.parentPath = this.$route.query.parentPath;
            this.autoApplyAndAudit = this.$route.query.autoApplyAndAudit || null;
            let bizUnitId = this.$route.query.bizUnitId;
            let comId = this.$route.query.comId;
            if (!Utils.isNoB(bizUnitId)) {
                let comInfo = {};
                comInfo.id = bizUnitId;
                let isAllowed = isSysRescFrozenIsAllowed(self, comInfo);
                if (isAllowed) {
                    this.clearVoucher.bizUnitId = bizUnitId;
                    this.clearVoucher.comId = comId;
                    this.clearVoucher.bizUnitName = this.$route.query.bizUnitName;
                }
            }
            syncSetBreadcrumb("清除单 - 制作", this.parentPath);
            //
            this.voucherId = this.$route.query.id || null;
            if (!Utils.isNoB(this.voucherId)) {
                this.getShopDeviceClearVoucherInfo();
            }
            //
            getMerchantBizParam("show.biz.unit.warehouse", function (result) {
                self.showBizUnitWarehouse = Utils.isTrue(result);
                if (Utils.isTrue(self.showBizUnitWarehouse)) {
                    self.getWarehouseList();
                }
            });
        },
        methods: {
            checkNull: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请选择!'));
                } else {
                    callback();
                }
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            // 选择仓库
            compareIn(val) {
                if (Utils.isNoB(this.voucherId)) {
                    this.clearVoucher.deviceItemList = [];
                } else {
                    if (val != this.clearVoucher.warehouseId) {
                        this.clearVoucher.deviceItemList = [];
                    }
                }
            },
            // 单原值校验
            inputOrgWorth: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 单净值校验
            inputNetWorth: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 额外费用校验
            inputTheFee: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 额外费用校验
            inputTheInc: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 清除可用数量校验
            inputClearQuantity: function (rule, value, callback) {
                if (!Utils.isNoB(value) && value < 0) {
                    callback(new Error('数量不能小于0！'));
                } else {
                    callback();
                }
            },
            // 清除数量变化校验
            quantityChange: function (scope) {
                if (Utils.isNaturalStr(scope.clearAvQuantity)) {
                    let maxQuantity = scope.inStkQuantity;
                    if (scope.fiscalAcctFlag == 1 && (scope.fiscalOutQuantity - scope.clearedQuantity) < maxQuantity) {
                        maxQuantity = scope.fiscalOutQuantity - scope.clearedQuantity;
                    }
                    if (maxQuantity < scope.clearAvQuantity) {
                        MsgBox.warning("当前清除数量" + scope.clearAvQuantity + "，大于可清除数量，可清除数量为：" + maxQuantity);
                    }
                }
            },
            //返回
            prevStock: function () {
                this.$router.back(-1);
            },
            // 仓库信息
            getWarehouseList: function () {
                let self = this;
                let clearVoucher = self.clearVoucher;
                let postData = {};
                postData.filterItems = {
                    retailerShopId: clearVoucher.bizUnitId
                };
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let wareHouseList = result.data || [];
                        wareHouseList.forEach(function (row) {
                            if (row.defaulted == true) {
                                self.clearVoucher.warehouseId = row.id;
                            }
                        });
                        self.wareHouseList = wareHouseList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopDeviceClearVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                let loading = MsgBox.loading();
                assetVchrApi.getShopDeviceClearVoucherIncludeItems(postData, function (result) {
                    loading.close();
                    if (result.type == "info") {
                        let clearVoucher = result.data;
                        self.clearVoucher = Utils.merge({}, clearVoucher);
                        //
                        self.autoApplyState = clearVoucher.applyState;
                        self.autoAuditPass = clearVoucher.auditState;
                        //
                        let itemList = clearVoucher.itemList || [];
                        self.clearVoucher.deviceItemList = Utils.merge([], itemList);
                        if (clearVoucher.srcVoucherType == 21) {
                            self.srcCheck = true;
                        }
                        //
                        self.showDeviceClearCase();
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 由于清除原因在页面显示慢，所以延时页面绑定
            showDeviceClearCase(){
                let self = this;
                let loading = MsgBox.loading();
                setTimeout(function () {
                    let deviceItemList = self.clearVoucher.deviceItemList || [];
                    deviceItemList.forEach(function (item) {
                        if (item.checked == null || item.checked == false) {
                            item.checked = true;
                        }
                        item.clearAvQuantity = item.quantity - item.quantity2;
                    });
                    self.clearVoucher.deviceItemList = Utils.merge([], deviceItemList);
                    self.clearVoucher = Utils.merge({}, self.clearVoucher);
                    loading.close();
                }, 500);
            },
            // 通用选择资产信息
            showDeviceListDlg: function () {
                let self = this;
                let clearVoucher = self.clearVoucher;
                let deviceItemList = clearVoucher.deviceItemList || [];
                let selectSingleIds = deviceItemList.pluck("deviceXId") || [];
                let params = {
                    filter: {
                        retailerComId: clearVoucher.bizUnitId,
                        warehouseId: clearVoucher.warehouseId || null,
                        locked: false,
                        fiscalAcctFlag: 0,
                        inStkQuantityFrom: 1
                    }, // 单品查询条件
                    devcBizClolumType: getEnumInfoWith("devcBizClolumType", "name", "QingChuDlg").name,   // 清除选择
                    initSelectIds: selectSingleIds || [], // 单品选择回显的ids
                    selectAll: true, // 同时可以选择单品及批量
                };
                showDevcSelectDlg(params, function (selectItemList) {
                    let deviceItems = self.stuffDeviceToItems(selectItemList) || [];
                    let items = deviceItemList.concat(deviceItems);
                    self.clearVoucher.deviceItemList = Utils.merge([], items);
                    //
                    self.showDeviceClearCase();
                });
            },
            // 单品组装清除单项
            stuffDeviceToItems: function (deviceItemList) {
                let itemsList = [];
                if (!Utils.isNoB(deviceItemList)) {
                    deviceItemList.forEach(function (deviceItem) {
                        let item = {
                            deviceXId: deviceItem.id,
                            durable: deviceItem.assetType == 0,
                            assetType: deviceItem.assetType,
                            rented: deviceItem.rented,
                            tmpNo: deviceItem.tmpNo,
                            innerNo: deviceItem.innerNo,
                            vendorUkno: deviceItem.vendorUkno,
                            catId: deviceItem.catId,
                            catName: deviceItem.catName,
                            brandId: deviceItem.brandId,
                            brandName: deviceItem.brandName,
                            title: deviceItem.title,
                            name: deviceItem.name,
                            model: deviceItem.model,
                            fixedSpec: deviceItem.fixedSpec,
                            modelSpec: deviceItem.modelSpec,
                            acctEnterWay: deviceItem.acctEnterWay,
                            orgWorth: deviceItem.orgWorth,
                            netWorth: deviceItem.netWorth,
                            assetKindId: deviceItem.assetKindId,
                            assetKindName: deviceItem.assetKindName,
                            innerDevcCatId: deviceItem.innerDevcCatId,
                            innerDevcCatName: deviceItem.innerDevcCatName,
                            inUseQuantity: deviceItem.inUseQuantity,
                            inStkQuantity: deviceItem.inStkQuantity,
                            inStkAvQuantity: deviceItem.inStkAvQuantity,
                            theUnit: deviceItem.theUnit,
                            batchNo: deviceItem.batchNo,
                            innerCode: deviceItem.innerCode,
                            svcNo: deviceItem.svcNo,
                            skuId: deviceItem.skuId,
                            goodsId: deviceItem.goodsId,
                            quantity: 1,
                            quantity2: 0,
                            theFee: 0,
                            theInc: 0,
                            clearCause: null,
                            fiscalAcctFlag: deviceItem.fiscalAcctFlag,
                            fiscalQuantity: deviceItem.fiscalQuantity,
                            fiscalOutQuantity: deviceItem.fiscalOutQuantity,
                            clearedQuantity: deviceItem.clearedQuantity,
                        };
                        itemsList.add(item);
                    });
                }
                return itemsList;
            },
            // 移除资产信息
            removeDeviceItem: function (index) {
                let self = this;
                self.$confirm('确定要移除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let deviceItemList = self.clearVoucher.deviceItemList || [];
                    let selectSingleIds = self.selectSingleIds || [];
                    let success = false;
                    for (let i = 0; i < deviceItemList.length; i++) {
                        if (i == index) {
                            let deviceItem = deviceItemList[i];
                            deviceItemList.remove(deviceItem);
                            selectSingleIds.remove(deviceItem.deviceXId);
                            success = true;
                        }
                    }
                    self.clearVoucher.deviceItemList = Utils.merge([], deviceItemList);
                    self.selectSingleIds = Utils.merge([], selectSingleIds);
                    if (success) {
                        Toast.show("移除成功！");
                    } else {
                        Toast.show("移除失败！");
                    }
                });
            },
            // 单行设置人员
            setStaffInfo: function (index) {
                let self = this;
                let clearVoucher = self.clearVoucher;
                let deviceItems = clearVoucher.deviceItemList;
                openComStaffMainForSelectDlg({bizUnitId: clearVoucher.bizUnitId, defComId: clearVoucher.comId}, function (result, theDlg) {
                    theDlg.close();
                    let item = deviceItems[index];
                    item.departId = result.srcComId;
                    item.departName = result.srcComName;
                    item.staffId = result.id;
                    item.staffName = result.name;
                    //
                    self.clearVoucher.deviceItemList = Utils.merge([], deviceItems);
                });
            },
            // 设置人员
            setStaff: function () {
                let self = this;
                let clearVoucher = self.clearVoucher;
                let deviceItems = clearVoucher.deviceItemList;
                openComStaffMainForSelectDlg({bizUnitId: clearVoucher.bizUnitId, defComId: clearVoucher.comId}, function (result, theDlg) {
                    theDlg.close();
                    deviceItems.forEach(function (item) {
                        item.departId = result.srcComId;
                        item.departName = result.srcComName;
                        item.staffId = result.id;
                        item.staffName = result.name;
                    });
                    self.clearVoucher.deviceItemList = Utils.merge([], deviceItems);
                });
            },
            selectDeviceClearDeasc: function () {
                let self = this;
                let itemList = self.clearVoucher.deviceItemList || [];
                let theDlg = Vue.$showDialog({
                    title: "清除原因",
                    width: 580,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>清除原因</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-select v-model="clearCause" clearable placeholder="请选择">' +
                    '<el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value">' +
                    '</el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        devcClearCauseList: self.devcClearCauseList,
                        clearCause: null
                    },
                    okClicked: function () {
                        let len = itemList.length;
                        for (let i = 0; i < len; i++) {
                            let item = itemList[i];
                            item.clearCause = this.clearCause;
                        }
                        self.clearVoucher.deviceItemList = Utils.merge([], itemList);
                    },
                    methods: {}
                });
            },
            setClearDeasc: function () {
                let self = this;
                let itemList = [];
                let clearVoucher = self.clearVoucher;
                let theDlg = Vue.$showDialog({
                    title: "清除原因",
                    width: 580,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>清除原因</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-select v-model="clearCause" clearable placeholder="请选择">' +
                    '<el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value">' +
                    '</el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        devcClearCauseList: self.devcClearCauseList,
                        clearCause: null
                    },
                    okClicked: function () {
                        clearVoucher.clearCause = this.clearCause;
                        clearVoucher.clearCauseName = getEnumInfoWith("devcClearCause", "value", this.clearCause).text;
                        self.clearVoucher = Utils.merge({}, clearVoucher);
                    },
                    methods: {}
                });
            },
            //
            saveDeviceIoVoucher: function () {
                if (!Utils.repeatChecker.isValidFor("saveDeviceIoVoucher", 1000)) {
                    return;
                }
                let self = this;
                if (Utils.isTrue(this.autoApplyAndAudit)) {  // 登记自动申请审核
                    this.autoApplyState = true;
                    this.autoAuditPass = true;
                }
                //
                self.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        let clearVoucher = self.clearVoucher;
                        clearVoucher.theDate = clearVoucher.theDate.format('yyyy-MM-dd');
                        let deviceItemList = clearVoucher.deviceItemList || [];
                        if (deviceItemList.length <= 0) {
                            Toast.show("请选择要清除的资产!");
                            return;
                        }
                        // 有资产的时候，校验资产相关数据
                        let includeInUseDevc = false;  // 是否包含再用单品式资产
                        if (deviceItemList.length > 0) {
                            let validateFailure = false;
                            self.$refs['deviceInfo'].validate(function (valid) {
                                if (!valid) {
                                    validateFailure = true;
                                    Toast.show("请输入资产中相应的数据！");
                                } else {
                                    for (let i = 0; i < deviceItemList.length; i++) {
                                        let item = deviceItemList[i];
                                        if (Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                            validateFailure = true;
                                            Toast.show("请为资产设置人员");
                                            break;
                                        }
                                        if (item.inUseQuantity > 0 && !includeInUseDevc) {
                                            includeInUseDevc = true;
                                        }
                                        //
                                        let clearAvQuantity = item.clearAvQuantity || 0;
                                        let quantity2 = item.quantity2 || 0;
                                        if (clearAvQuantity <= 0) {
                                            validateFailure = true;
                                            Toast.show("资产【" + item.title + "】清除可用数量请输入正整数！");
                                            break;
                                        }
                                        //
                                        let maxQuantity = item.inStkQuantity;
                                        if (item.fiscalAcctFlag == 1 && (item.fiscalOutQuantity - item.clearedQuantity) < maxQuantity) {
                                            maxQuantity = item.fiscalOutQuantity - item.clearedQuantity;
                                        }
                                        if (maxQuantity < clearAvQuantity) {
                                            validateFailure = true;
                                            Toast.show("资产【" + item.title + "】当前清除数量" + clearAvQuantity + "，大于可清除数量，可清除数量为：" + maxQuantity + "，请调整清除数量");
                                            break;
                                        }
                                        item.quantity = clearAvQuantity + quantity2;
                                    }
                                }
                            });
                            if (validateFailure) {
                                return;
                            }
                        }
                        if (deviceItemList.length > 500) {
                            MsgBox.warning("最大单据级条目为500条！现" + itemList.length + "条！");
                            return;
                        }
                        clearVoucher.itemList = Utils.merge([], deviceItemList);
                        clearVoucher.autoApplyState = self.autoApplyState;
                        clearVoucher.autoAuditPass = self.autoAuditPass;
                        clearVoucher.updateDevice = true;
                        clearVoucher.updateOrgNetWorthFlag = false;   // 更新单原值单净值;
                        if (includeInUseDevc) {
                            self.$confirm('清除资产中如果包含在用将自动归还！', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                self.saveShopDeviceCleardVoucher(clearVoucher);
                            });
                        } else {
                            self.saveShopDeviceCleardVoucher(clearVoucher);
                        }
                    }
                });
            },
            saveShopDeviceCleardVoucher: function (clearVoucher) {
                let self = this;
                let theLoad = MsgBox.loading();
                assetVchrApi.saveShopDeviceClearVoucher(clearVoucher, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        MsgBox.success("保存成功");
                        self.$router.push({
                            path: self.parentPath
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            selectBizUnitName: function () {
                let self = this;
                let clearVoucher = self.clearVoucher;
                let dlgConfig = {};
                dlgConfig.isRadio = true;
                dlgConfig.isShowIcons = false;
                dlgConfig.enableSearch = true;
                dlgConfig.title = '机构--选择';
                openBizUnitOrgTreeDlg(dlgConfig, function (result) {
                    clearVoucher.bizUnitId = result.bizUnitId;
                    clearVoucher.bizUnitName = result.bizUnitName;
                    clearVoucher.comId = result.id;
                    clearVoucher.comName = result.name;
                    self.clearVoucher = Utils.merge({}, clearVoucher);
                    if (Utils.isTrue(self.showBizUnitWarehouse)) {
                        self.getWarehouseList();
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/clearVoucher/ShopDeviceClearVoucherSave.vue